export default "__VITE_ASSET__FCk$jUtH__"